jQuery(function(){

	jQuery('#MobileNav > li:nth-child(2) > a, #MobileNav > li:nth-child(3) > a, #MobileNav > li:nth-child(4) > a, #MobileNav > li:nth-child(5) > a').attr('href', 'javascript:void(0)');
  
    jQuery('#MobileNav > li:nth-child(2) > a').click(function () {
            jQuery('#da-couples-box-hide-mobile').toggle();
            jQuery('#da-men-box-hide-mobile').hide();
            jQuery('#da-women-box-hide-mobile').hide();
            jQuery('#da-collections-box-hide-mobile').hide();
            jQuery(this).children('img').toggleClass('da-rotate');
            jQuery('#MobileNav > li:nth-child(3) > a > img, #MobileNav > li:nth-child(4) > a > img, #MobileNav > li:nth-child(5) > a > img').removeClass('da-rotate');
        });
  
  jQuery('#MobileNav > li:nth-child(3) > a').click(function () {
            jQuery('#da-men-box-hide-mobile').toggle();
            jQuery('#da-couples-box-hide-mobile').hide();
            jQuery('#da-women-box-hide-mobile').hide();
            jQuery('#da-collections-box-hide-mobile').hide();
            jQuery(this).children('img').toggleClass('da-rotate');
            jQuery('#MobileNav > li:nth-child(2) > a > img, #MobileNav > li:nth-child(4) > a > img, #MobileNav > li:nth-child(5) > a > img').removeClass('da-rotate');
        });
  
  jQuery('#MobileNav > li:nth-child(4) > a').click(function () {
            jQuery('#da-women-box-hide-mobile').toggle();
            jQuery('#da-couples-box-hide-mobile').hide();
            jQuery('#da-men-box-hide-mobile').hide();
            jQuery('#da-collections-box-hide-mobile').hide();
            jQuery(this).children('img').toggleClass('da-rotate');
            jQuery('#MobileNav > li:nth-child(2) > a > img, #MobileNav > li:nth-child(3) > a > img, #MobileNav > li:nth-child(5) > a > img').removeClass('da-rotate');
        });
  
  jQuery('#MobileNav > li:nth-child(5) > a').click(function () {
            jQuery('#da-collections-box-hide-mobile').toggle();
            jQuery('#da-couples-box-hide-mobile').hide();
            jQuery('#da-men-box-hide-mobile').hide();
            jQuery('#da-women-box-hide-mobile').hide();
            jQuery(this).children('img').toggleClass('da-rotate');
            jQuery('#MobileNav > li:nth-child(2) > a > img, #MobileNav > li:nth-child(4) > a > img, #MobileNav > li:nth-child(3) > a > img').removeClass('da-rotate');
        });

})